import { Descope } from '@descope/react-sdk';
import { SIGN_IN_FLOW_ID } from '../config/auth';

export function SignInPage() {
  return (
    <main>
      <Descope flowId={SIGN_IN_FLOW_ID} />
    </main>
  );
}
